<template>
  <div
    v-loading="loading"
    element-loading-text="loading ……"
    class="main-wrapper my-2"
    :style="{ height: `${listHeight}px` }"
  >
    <div class="my-2" v-for="(item, index) in data" :key="index">
      <TimelineCard
        :items="item.items"
        :showType="showType"
        :cardKey="
          `${item.meetingDate}${item.meetingWeek}${
            showType === 'A'
              ? item.v_meetingTimeZone
              : $l('table_label_localTime') || 'Local Time'
          }`
        "
      >
        <template slot="title">
          <div class="timeline-card-title">
            <span>{{ item.meetingDate }}</span>
            <span>{{ item.meetingWeek }}</span>
            <span>{{
              showType === 'A'
                ? item.v_meetingTimeZone
                : $l('table_label_localTime') || 'Local Time'
            }}</span>
          </div>
        </template>
        <template #menus="{item}">
          <div style="text-align: center">
            <el-dropdown trigger="click" @command="optCommand">
              <div class="el-dropdown-link">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 128 512"
                  style="width: 6px;"
                  fill="#6c757d"
                >
                  <path
                    d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
                  />
                </svg>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(opt, index) in opts"
                  :key="index"
                  :icon="opt.icon"
                  :command="{ opt, data: item }"
                  :divided="opt.divided"
                  :disabled="
                    opt.disabled == undefined ? false : opt.disabled(item)
                  "
                >
                  {{ opt.text }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>

        <template #opts="{item}">
          <div class="timeline-opt">
            <el-tag
              size="mini"
              effect="dark"
              :type="item.meetingImportantLevel"
            >
              {{ item.v_meetingImportantLevel }}
            </el-tag>

            <div class="ml-4 opt-btn">
              <div @click="$emit('open-comments-doc', item)">
                <div class="mr-3">
                  <i class="el-icon-chat-line-square" />
                  <span class="ml-1">
                    {{ item.commentsCount || 0 }}
                  </span>
                </div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$l('btn_docs') || '会议文档'"
                  placement="top-start"
                >
                  <i
                    class="el-icon-link"
                    style="color: #bbbbbb;font-weight: bold;"
                  />
                </el-tooltip>
              </div>
            </div>
          </div>
        </template>
      </TimelineCard>
    </div>
    <div v-if="isEmpty" class="empty-data">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import Opts from './opts'
import TimelineCard from '../timeline-card'
export default {
  mixins: [EditLoading],
  components: { TimelineCard },
  props: {
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    showType: { type: String, default: '' },
  },
  data() {
    return { listHeight: 600 }
  },
  computed: {
    opts() {
      const opts = Opts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
    isEmpty() {
      return !this.data?.length
    },
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      this.listHeight = window.innerHeight - 197
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return
      switch (menuType) {
        case 'edit':
        case 'confirm':
          this.$emit('openEdit', { type: menuType, data })
          break
        case 'cancel':
          this.cancel(data)
          break
        case 'detail':
          this.detail(data)

          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async cancel({ expoMeetingCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_cancelMeeting'),
        this.$l('tips_confirmInfo'),
        {
          confirmButtonText: this.$l('btn_confirm'),
          cancelButtonText: this.$l('btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.loadingOpen()
      const res = await this.$api
        .expoMeetingCancelApi({ expoMeetingCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status, msg } = res
      if (status === 203) {
        this.$confirm(msg, this.$l('INDEX.label_completeDesc') || '确认信息', {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
        })
        return
      }
      if (status !== 200) {
        this.$message.error(this.$l('tips_cancel_no') || '取消失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_cancel_ok') || '取消成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async detail({ expoMeetingCode, custName, meetingDate, expoInfoCode }) {
      this.loadingOpen()
      const res = await this.$api
        .expoMeetingCheckAuthApi({ expoMeetingCode, checkType: 'A' })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status, msg } = res
      if (status === 203) {
        this.$confirm(msg, this.$l('INDEX.label_completeDesc') || '确认信息', {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
        })
        return
      }
      if (status === 200) {
        this.$router.push({
          name: 'expo-meetingSet-detail',
          params: { expoMeetingCode, expoInfoCode },
          query: { custName, meetingDate },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.main-wrapper {
  overflow-y: auto;
  > div:first-child {
    margin-top: 0 !important;
  }
  > div:last-child {
    margin-bottom: 0 !important;
  }
  .timeline-card-title {
    span {
      margin-right: 10px;
    }
  }
}

::v-deep {
  .el-dropdown-link {
    width: 10px;
  }
}

.timeline-opt {
  display: flex;
  align-items: center;
  font-size: 23px;
  [class^='el-icon'] {
    font-size: 22px !important;
    color: #bbbbbb !important;
    font-weight: bold !important;
  }
  .opt-btn {
    flex: 1;
    display: flex;
    > div {
      cursor: pointer;
      display: flex;
      align-items: center;
    }
  }
}
.empty-data {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .no-data {
    font-size: 14px;
    color: #606266;
  }
}

::v-deep {
  .opts-col .text_label .label {
    display: none;
    margin-bottom: 0 !important;
    line-height: 1.5 !important;
  }
  @media only screen and (min-width: 992px) {
    .opts-col .text_label .label {
      display: block;
    }
  }
}
</style>
